var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { styled } from 'styled-components';
export var Title = styled.h2.withConfig({ displayName: "Title", componentId: "sc-1p7tj74" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 32px;\n  color: ", ";\n  margin: 0;\n"], ["\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 32px;\n  color: ", ";\n  margin: 0;\n"])), function (_a) {
    var t = _a.theme;
    return t.colors.black20;
});
export var Paragraph = styled.p.withConfig({ displayName: "Paragraph", componentId: "sc-1grhm44" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: 16px;\n  line-height: 24px;\n  color: ", ";\n  margin: 0;\n"], ["\n  font-size: 16px;\n  line-height: 24px;\n  color: ", ";\n  margin: 0;\n"])), function (_a) {
    var t = _a.theme;
    return t.colors.black10;
});
var templateObject_1, templateObject_2;
